import type { ComponentStyleConfig } from "@chakra-ui/react";

export const dividerStyle: ComponentStyleConfig = {
  baseStyle: {
    opacity: 1,
    borderColor: "white",
    borderBottomWidth: "1.5px",
  },
};
